export default __webpack_public_path__ + "media/images/react_icons/property/parking-c05e2fd487214b9aed6a371102129410.svg";